import {apiBase} from 'api/base.js';

class FarmMovingAPI {
  create(params) {
    return apiBase.post('/admin/temporary/farm_moving', params);
  }
}

export const farmMovingAPI = new FarmMovingAPI();
